import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ClarityServiceService {

  private isLoaded = false;
  private clarityScriptUrl = 'https://www.clarity.ms/tag/lz92c71h9u'; 

  loadClarity(userId : string): void {


    if ((window as any).clarity) return; // Ya cargado

  (window as any).clarity = function (...args: any[]) {
    ((window as any).clarity.q = (window as any).clarity.q || []).push(args);
  };
  (window as any).clarity.v = false;
  (window as any).clarity.t = false;

  const script = document.createElement('script');
  script.src = 'https://www.clarity.ms/tag/lz92c71h9u';
  script.async = true;
  script.onload = () => {
    (window as any).clarity('set', 'userId', userId);
    console.log('✅ Clarity loaded and user ID set');
  };
  document.head.appendChild(script);

  }
}
